module.exports = __webpack_public_path__ + "img/header.ae7b7a51.png";